/** Deep-merge locale overrides onto English defaults (arrays replaced, not merged). */
export function deepMergeLocale(base, override) {
  if (!override || typeof override !== "object") return base;
  const out = { ...base };
  for (const key of Object.keys(override)) {
    const bv = base?.[key];
    const ov = override[key];
    if (
      ov &&
      typeof ov === "object" &&
      !Array.isArray(ov) &&
      bv &&
      typeof bv === "object" &&
      !Array.isArray(bv)
    ) {
      out[key] = deepMergeLocale(bv, ov);
    } else {
      out[key] = ov;
    }
  }
  return out;
}
